<template>
  <div style="height:50px;">
    <van-tabbar :active-color="$abctheme.basecolor" route>
      <van-tabbar-item icon="wap-home" to="/home">首页</van-tabbar-item>
      <!-- <van-tabbar-item icon="smile-comment" to="/foodmore">能不能吃</van-tabbar-item> -->
      <!-- <van-tabbar-item icon="comment" to="/communityindex">育儿</van-tabbar-item> -->
       <van-tabbar-item icon="comment" @click="noto">育儿</van-tabbar-item>
      <!-- <van-tabbar-item icon="wap-nav" to="/assist/assist">物料铺</van-tabbar-item> -->
      <van-tabbar-item icon="cart" to="/cart">购物车</van-tabbar-item>
      <van-tabbar-item icon="contact" to="/user/index">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from "vant";
export default {
  name: "navigate",
  data() {
    return {};
  },
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
  },
  methods: {
    noto(){
      this.$dialog.alert({
        title:'功能建设中,敬请期待~'
      })
    }
  },
};
</script>

